import type { Certificate, SkillAnalytics, StudentDashboard, TeacherDashboard } from '@lms/shared'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useDashboard() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: () => api.get<StudentDashboard>('/api/dashboard'),
  })
}

export function useTeacherDashboard() {
  return useQuery<TeacherDashboard>({
    queryKey: ['dashboard', 'teacher'],
    queryFn: () => api.get<TeacherDashboard>('/api/dashboard/teacher'),
  })
}

export function useCertificates() {
  return useQuery<Certificate[]>({
    queryKey: ['dashboard', 'certificates'],
    queryFn: () => api.get('/api/dashboard/certificates'),
  })
}

export function useSkillAnalytics() {
  return useQuery<SkillAnalytics>({
    queryKey: ['dashboard', 'skill-analytics'],
    queryFn: () => api.get('/api/dashboard/skill-analytics'),
  })
}
